module.exports = __webpack_public_path__ + "static/media/videogame-img.f431ff55.png";